<template>
  <div class="submitted-offers-combined container-fluid">
    <div class="row title-row">
      <div class="col-6">Submitted {{titleType}}</div>
      <div class="col-6" v-if="consumer">
        <Progress :currentValue="successfulSubmits.length" :maxValue="consumer.max_offer_submission"></Progress>
      </div>
    </div>
    <div class="row offers-row">
      <SubmittedOfferSmall class="col-12" v-for="(offer, index) in submitsNoBulkPending" :class="{ last: index === submits.length-1 && pendingRequests.length === 0 }" :key="offer.offer.displayedOfferId ?? offer.offer.id" :offer="offer"></SubmittedOfferSmall>
      <PendingOffer class="col-12" v-for="(offer, index) in pendingRequests" :class="{ last: index === pendingRequests.length-1 }" :key="offer.displayedOfferId" :offer="offer"></PendingOffer>
      <div class="col-12 no-submitted-offers" v-show="submits.length === 0 && pendingRequests.length === 0">
        Currently no signed up offers.
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import SubmittedOfferSmall from './mini-offers/SubmittedOfferSmall.vue'
import PendingOffer from './mini-offers/PendingOffer.vue'
import Progress from '../basic-elements/Progress.vue'

export default {
  name: 'SubmittedOffersCombined',
  props: ['type'],
  emits: [],
  components: {
    Progress,
    PendingOffer,
    SubmittedOfferSmall
  },
  data () {
    return {
    }
  },
  computed: {
    successfulSubmits () {
      return this.submitsNoBulkPending.filter((offer) => offer.status === 'Accepted')
    },
    titleType () {
      return this.type ?? 'Schools'
    },
    submitsNoBulkPending () {
      return this.submits.filter((offer) => !this.bulkPending.some((bulk) => (bulk.offer.displayedOfferId ?? bulk.offer.id) === (offer.offer.displayedOfferId ?? offer.offer.id)))
    },
    ...mapState({
      consumer: state => state.consumer.currentConsumer,
      pendingRequests: state => state.consumer.leadRequests.pendingLeadRequests,
      bulkPending: state => state.consumer.leadRequests.pendingBulkSubmits
    }),
    ...mapGetters({
      submits: 'consumer/leadRequests/getRequests'
    })
  },
  methods: {
  }
}
</script>

<style scoped>
.row {
  margin-right: calc(var(--bs-gutter-x) * -1);
  margin-left: calc(var(--bs-gutter-x) * -1);
}
.submitted-offers-combined {
  border: 1px solid #d6e9c6;
  margin-bottom: 20px;
  border-radius: .25em;
}
.submitted-offers-combined .title-row {
  padding: 20px 0;
  border-bottom: 1px solid #d6e9c6;
  color: #3c763d;
  background-color: #dff0d8;
}
.submitted-offer-small {
  border-bottom: 1px solid #ddd;
  min-height: 56px;
}
.submitted-offer-small.last {
  border: none;
}
.no-submitted-offers {
  padding-top: 10px;
  padding-bottom: 25px;
}
@media screen and (min-width: 1200px) {
  .submitted-offer-small {
    padding-left: calc(var(--bs-gutter-x));
  }
}
</style>
